import authApi from "../../../contextProviders/auth-api";
import {
  apiList,
  userActions,
  methodType,
} from "../../../contextProviders/constant";

const createAccountingConnection = async (
  tokenhandler,
  partnerAccountId,
  authCode,
) => {
  const minDuration = 1000; // Minimum duration to show loading state

  const makeRequest = async () => {
    const url = apiList[userActions.accountingConnectionCreate];
    return await authApi({
      body: {
        partner_company_code: "qbo",
        partner_account_id: partnerAccountId,
        auth_code: authCode,
      },
      method: methodType.post,
      url,
      isWithCredentials: false,
      tokenhandler,
      isSecured: true,
    });
  };

  try {
    const [response] = await Promise.all([
      makeRequest(),
      new Promise((resolve) => setTimeout(resolve, minDuration)),
    ]);

    return {
      success: response?.status === 200,
      status: response?.status,
      data: response?.data,
    };
  } catch (error) {
    await Promise.all([
      Promise.resolve(error),
      new Promise((resolve) => setTimeout(resolve, minDuration)),
    ]);

    return {
      success: false,
      status: 500,
      data: { message: "Unknown error occurred" },
    };
  }
};

const helper = { createAccountingConnection };
export default helper;
